/* eslint-disable no-nested-ternary */
import { Box } from "@mui/material";
import { useTheme } from "@mui/styles";
import React from "react";
import { convertAnswer } from "../../../../utils/helpers/helpers";
import { ShowBasicDataContent } from "../Elements";

type TManyAnswerCardProps = {
  answerTotalQuestion: any;
  questionId: any;
  selectionId: any;
  ix: any;
  items: any;
  solutionData: any;
  chooseAnswer: any;
};

function ManyAnswerCard({
  answerTotalQuestion,
  questionId,
  selectionId,
  ix,
  items,
  solutionData,
  chooseAnswer
}: TManyAnswerCardProps) {
  const theme: any = useTheme();
  return (
    <Box>
      {solutionData ? (
        <Box
          className="sm:w-[90vw] md:w-[325px] sm:mr-5 md:mr-6 border border-gray"
          style={{
            background:
              solutionData?.skipped && solutionData?.correct_options?.includes(selectionId)
                ? theme.answerOptions.skipped
                : solutionData?.correct && solutionData?.correct_options?.includes(selectionId)
                ? theme.answerOptions.correct
                : !solutionData?.skipped &&
                  !solutionData?.correct &&
                  solutionData?.answered_options?.includes(selectionId) &&
                  !solutionData?.correct_options?.includes(selectionId)
                ? theme.answerOptions.inCorrect
                : !solutionData?.skipped &&
                  !solutionData?.correct &&
                  solutionData?.answered_options?.includes(selectionId) &&
                  solutionData?.correct_options?.includes(selectionId)
                ? theme.answerOptions.correct
                : !solutionData?.skipped &&
                  !solutionData?.correct &&
                  !solutionData?.answered_options?.includes(selectionId) &&
                  solutionData?.correct_options?.includes(selectionId)
                ? theme.answerOptions.purple
                : "white",
            color:
              solutionData?.correct_options.includes(selectionId) ||
              (solutionData?.answered_options && solutionData?.answered_options.includes(selectionId))
                ? "white"
                : "black",
            borderRadius: 6,
            marginBottom: 12,
            padding: 8,
            display: "flex"
          }}
        >
          {convertAnswer(ix)}&nbsp;
          <div className="flex flex-col">
            {items.map((item, idx) => (
              <ShowBasicDataContent key={idx} ele={{ content_type: item?.content_type, content: item?.content }} />
            ))}
          </div>
        </Box>
      ) : (
        <Box
          className="sm:w-[90vw] md:w-[325px] sm:mr-5 md:mr-6 border text-[15px] text-blackQuiz"
          style={{
            borderColor: answerTotalQuestion?.selections.includes(selectionId)
              ? theme.answerOptions.correct
              : theme.answerOptions.gray,
            borderRadius: 6,
            marginBottom: 12,
            padding: 8,
            display: "flex",
            cursor: "pointer"
          }}
          onClick={() => {
            chooseAnswer(selectionId, questionId);
          }}
        >
          {convertAnswer(ix)}&nbsp;
          <div className="flex flex-col">
            {items?.map((item, idx) => (
              <ShowBasicDataContent key={idx} ele={{ content_type: item?.content_type, content: item?.content }} />
            ))}
          </div>
        </Box>
      )}
    </Box>
  );
}

export default ManyAnswerCard;
